/**
 * @generated SignedSource<<a2c198757da87fb835b52b69976522af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment$data = {
  readonly bundleIds: ReadonlyArray<string>;
  readonly id: string;
  readonly " $fragmentType": "ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment";
};
export type ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment$key = {
  readonly " $data"?: ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bundleIds",
      "storageKey": null
    }
  ],
  "type": "IHKCertificateBundle",
  "abstractKey": null
};

(node as any).hash = "ac083b64b9414277872a39b46c2e95cc";

export default node;
